module.exports = __webpack_public_path__ + "static/media/select-fire_rapidstrike_kit_accessories.af90321a.jpg";